// Renders the "Cele mai populare modele" block inside the right-rail sidebar
// shared by the info pages. Re-uses the .ap-search-card markup from the
// header-search "Mașini populare" widget so we get a card pattern the user
// already knows. Picks the first 4 featured listings from AP_DATA.
import { qs } from '../lib/dom.js';
import { AP_DATA } from '../data/listings.js';
import { num } from '../lib/format.js';

function searchCardHTML(l) {
  return `
    <a class="ap-search-card" href="listing.html?id=${l.id}">
      <div class="ap-search-card__photo">
        <img src="${l.image}" alt="" loading="lazy" decoding="async">
      </div>
      <div class="ap-search-card__body">
        <div class="ap-search-card__title">${l.title}</div>
        <div class="ap-search-card__price">${num(l.price)} €</div>
      </div>
    </a>
  `;
}

export function initInfoSidebar() {
  const slot = qs('[data-role="popular-listings"]');
  // WP renders the featured-model cards server-side (atpl_featured_model_cards)
  // - only fill from prototype AP_DATA when the slot arrived empty, otherwise
  // this wipes the real cards (AP_DATA has no `featured` listings in WP).
  if (!slot || slot.children.length) return;
  const cars = AP_DATA.listings
    .filter((l) => l.featured)
    .slice(0, 4);
  slot.innerHTML = cars.map(searchCardHTML).join('');
}
